<h3 class="wf-peppol-detail-sbdh__heading wf-text-sm-medium">
  {{ 'PEPPOL.Detail.SbdhSection' | translate }}
</h3>

<wf-property-list [entries]="entries()" />
